require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./heritage-precinct-sheahan-townhouses.json") })
        }
      }, "path---heritage-precinct-sheahan-townhouses");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---heritage-precinct-sheahan-townhouses!./.cache/json/heritage-precinct-sheahan-townhouses.json
// module id = 769
// module chunks = 231608221292675